import { useState } from 'react';
import { defaultAes, defaultApi, defaultCdn, defaultFileWs, defaultMsgWs } from '@shared/config/runtime';

export function useWorkspaceConfig() {
  const [apiBase, setApiBase] = useState(defaultApi);
  const [msgWsUrl, setMsgWsUrl] = useState(defaultMsgWs);
  const [fileWsUrl, setFileWsUrl] = useState(defaultFileWs);
  const [aesKey, setAesKey] = useState(defaultAes);
  const [cdnBase, setCdnBase] = useState(defaultCdn);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return {
    apiBase,
    setApiBase,
    msgWsUrl,
    setMsgWsUrl,
    fileWsUrl,
    setFileWsUrl,
    aesKey,
    setAesKey,
    cdnBase,
    setCdnBase,
    email,
    setEmail,
    password,
    setPassword,
  };
}
